import { styled } from "@mui/material/styles";

// Components
import { StyledCard } from "~/components/Common";

const styledName = "CategoryPicker";

export const StyledWrapper = styled(StyledCard, { name: styledName })({
  "&": {
    padding: "25px 20px 10px 20px",
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    width: "100%",
    maxWidth: 0,
    top: 0,
    right: 0,
    left: 0,
    zIndex: 1,
    transform: "scaleX(0)",
    animation: `show 0.3s ease-in forwards`,
    "@keyframes show": {
      from: { maxWidth: 0, transform: "scaleX(0)", opacity: 0 },
      to: { maxWidth: "100%", transform: "scaleX(1)", opacity: 1 },
    },
  },
});

export const StyledHeader = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    alignItems: "center",
    marginTop: "-20px",
  },
});
